module.exports = __webpack_public_path__ + "img/vipps-logo.43fcf7f9.png";